import { createRouter, createWebHistory } from 'vue-router'

import Login from '~/views/useraccount/login'
import Install from '~/views/install/index'
import Launcher from '~/views/launch/launcher'
import Migration from '~/views/launch/migration'
import Root from '~/views/shared/_layout-app'
import PasswordRecovery from '~/views/useraccount/password-recovery'

export const routes = [
  { path: '/', redirect: '/dashboard/home' },
  { path: '/dashboard', component: Root, name: 'home' },
  { path: '/dashboard/:page', component: Root, name: 'page' },
  { path: '/login', component: Login, name: 'login' },
  { path: '/install', component: Install, name: 'install' },
  { path: '/launch', component: Launcher, name: 'launcher' },
  { path: '/migration', component: Migration, name: 'migration' },
  { path: '/resetpassword', component: PasswordRecovery, name: 'recovery' },
  { path: '/:pathMatch(.*)*', redirect: '/dashboard/home' }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from) => {
  if((from.name === 'launcher' || from.name === 'migration') && to.name === 'login')
    return false
  return true
})

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return originalPush.call(this, location).catch(err => {
//     if (err.name !== 'NavigationDuplicated') throw err
//   })
// }

export default router
